import { Component, OnInit } from '@angular/core';
import {UploadsAdminService} from "../../../services/uploads-admin.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {Observable} from "rxjs";
import {HttpClient, HttpParams, HttpResponse} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {Location} from "@angular/common";

@Component({
  selector: 'app-image-detail',
  templateUrl: './image-detail.component.html',
  styleUrls: ['./image-detail.component.css']
})
export class ImageDetailComponent implements OnInit {
  albumId: string;
  fileName: string;
  previewUrlSafe: SafeResourceUrl;
  previewFileOpen: boolean;
  previewType: number;
  previewErrorMsg: string|null;
  isLoadingPreview = false;
  previewFilename: string|null;

  constructor(
    private uploadsAdminService: UploadsAdminService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.albumId = params['albumId'];
      this.fileName = params['fileName'];

      this.loadFilePreview();

    });
  }

  loadFilePreview() {
    this.getFileInline(this.fileName).subscribe(result => {
      const disposition = result.headers.get('Content-Disposition');
      const contentType = result.headers.get('Content-Type');
      const filename = disposition.split(';')[1].trim().split('=')[1];

      const blob = new Blob([result.body], { type: contentType });
      // FileSaver.saveAs(blob , filename);
      const fileURL = URL.createObjectURL(blob);


      this.previewUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      if ( contentType.indexOf('image') >= 0) {
        this.previewType = 2;
      } else {
        this.previewType = 1;
      }
      this.previewErrorMsg = null;
      this.previewFilename = filename;
      this.isLoadingPreview = false;
      this.previewFileOpen = true;
    })
  }

  getFileInline( fileName: string ): Observable<HttpResponse<Blob>> {

    const params = new HttpParams()
      .set('inline', true.toString());

    return this.http.get( 'uploads/' + fileName, { params: params, responseType: 'blob', observe: 'response' } );
  }


  returnBack() {
    this.location.back();
  }
}
